<template>
  <div class="col-lg-12">
    <div class="row d-flex justify-content-between">
      <div class="d-flex align-items-center">
        <span class="ml-2 label-bold color-dark-purple">ATIVIDADES/CURSOS EXTRA CURRICULARES</span>
      </div>
      <div>
        <button
          type="button"
          class="f14 btn-add-items-tb bg-light-purple color-white"
          @click="openForm()"
        >
          ADICIONAR
        </button>
      </div>
    </div>
    <div class="mt-3">
      <div
        class="d-flex justify-content-center align-item-center row mb-1 border-dark-purple pt-3 pb-4"
        v-if="extra_courses.length === 0"
      >
        <h4 class="center f15 color-dark-purple">
          NENHUMA ATIVIDADE/CURSO EXTRACURRICULAR FOI INFORMADO AINDA.
        </h4>
      </div>
    </div>

    <div
      v-for="(extra_course, index) in extra_courses"
      :key="extra_course.id"
    >
      <div class="mt-3">
        <div class="row mb-1 border-dark-purple pt-3 pb-4">
          <div class="col-lg-12">
            <div>
              <div class="d-flex justify-content-between">
                <div>
                  <span
                    class="label-bold color-dark-purple"
                    style="text-transform: capitalize"
                  >{{ extra_course.name }}</span>
                </div>
                <div
                  style="margin-right: 10px !important"
                  class="menu_column nav nav-tabs"
                >
                  <li
                    style="background-color: #f4f4f4 !important"
                    class="nav-item dropdown"
                  >
                    <div
                      class="nav-link"
                      data-toggle="dropdown"
                      role="button"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style="background-color: #fcfcfc"
                    >
                      <font-awesome-icon icon="ellipsis-h" />
                    </div>
                    <div class="dropdown-menu drop-down-tb">
                      <div class="dropdown-item pointer">
                        <span
                          class="mt-0 mb-0"
                          @click="openForm(extra_course.id)"
                        >
                          EDITAR
                        </span>
                        <i class="ml-4 fa fa-pencil-alt scale_1" />
                      </div>
                      <div class="dropdown-item pointer">
                        <span
                          class="mt-0 mb-0"
                          @click="deleteExtraCourse(extra_course.id, index)"
                        >
                          DELETAR
                        </span>
                        <i class="ml-3 fas fa-trash-alt scale_1" />
                      </div>
                    </div>
                  </li>
                </div>
              </div>
              <div>
                <span style="text-transform: capitalize">{{ extra_course.institution }}</span>  
              </div>
              <div>
                <div>
                  <span style="text-transform: capitalize">
                    {{ extra_course.start_date }} - {{ extra_course.end_date }}
                  </span>
                </div>
              </div>
              <div class="mt-3">
                <div>
                  <span>Descrição:</span>
                </div>
                <div>
                  <span style="text-transform: capitalize">{{
                    extra_course.description
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ExtraCoursesForm from "./Form.vue";
import { format } from "date-fns";
import axios from "axios";

export default {
  props: ["candidate_id"],
  mounted() {
    eventBus.$on("getExtraCourses", () => {
      this.getExtraCourses();
    });

    this.getExtraCourses();
  },
  data: () => ({
    extra_courses: [],
  }),
  methods: {
    getExtraCourses() {
      this.extra_courses = [];
      let url = "/candidates/extra_courses";
      if (this.candidate_id) {
        url = `/recruiters/talent_banks/${this.candidate_id}/extra_courses`;
      }
      axios.get(url).then((response) => {
        for (let extra_course of response.data.extra_courses) {
          if( extra_course.type_courses === 1 ){
            this.extra_courses.push({
              id: extra_course.id,
              name: extra_course.name,
              description: extra_course.description,
              start_date: extra_course.start_date
                ? format(new Date(extra_course.start_date), "MM/yyyy")
                : "",
              end_date: extra_course.end_date
                ? format(new Date(extra_course.end_date), "MM/yyyy")
                : "",
              institution: extra_course.institution_name,
            });
          }
        }
      });
    },
    openForm(id) {
      this.$modal.show(
        ExtraCoursesForm,
        {
          extra_course_id: id,
          candidate_id: this.candidate_id,
        },
        {
          width: "70%",
          height: "auto",
          scrollable: true,
        }
      );
    },
    deleteExtraCourse(id, index) {
      let conf = confirm("Tem certeza que deseja excluir este dado?");
      if (!conf) return;

      let url = `/candidates/extra_courses/${id}`;
      if (this.candidate_id) {
        url = `/recruiters/talent_banks/extra_courses/${id}`;
      }

      axios.delete(url).then((response) => {
        if (response.data.status) {
          this.$toast.success("Atividade/Curso extracurricular excluido com sucesso!");
          this.extra_courses.splice(index, 1);
          return;
        }

        this.$toast.error("Não foi possivel excluir esta atividade/curso extracurricular.");
      });
    },
  },
};
</script>